import { useEffect } from 'react';

import call from 'utils/functions/call.util';
import deRef from 'utils/objects/deRef.util';

const useOnClickOutside = (targetRef, handler) => {
  const element = deRef(targetRef);

  useEffect(() => {
    const listener = (ev) => {
      const { target } = ev;

      if (!element || element.contains(target) || element === target) {
        return;
      }

      call(`useOnClickOutside.handler`, handler, ev);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [handler, element]);
};

export default useOnClickOutside;
